import BaseModel from './base';

class FolderModel extends BaseModel {
	async getFolderById(id) {
		return this.get(`/${id}`);
	}

	async getFolders(options = {}) {
		const query = new URLSearchParams(options);

		const result = await this.get(`/?${query}`);

		if (result?.folders) {
			result.folders = result.folders.map(tx => this.replacePipeline(tx));
		}

		return result;
	}

	createFolder(name, parentId) {
		return this.post(`/`, { body: { name, parentId } });
	}

	updateFolder(folderId, name, parentId) {
		const headers = {};
		return this.put(`/${folderId}`, {
			body: { name, parentId },
			headers
		});
	}

	deleteFolder(folderId) {
		return this.delete(`/${folderId}`);
	}

	batchMoveTransactions(folderId, transactions) {
		return this.patch(`/${folderId}/batch-move-transactions`, {
			body: transactions
		});
	}

	batchRemoveTransactions(transactions) {
		return this.patch(`/batch-remove-transactions`, {
			body: transactions
		});
	}
}

export default new FolderModel('/folder');
